import { createClient } from 'contentful';

const SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID || 'tbu6yo6b5o8c';
const ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || 'e218c3e95c9baa00b1ba82bc971f8636489205545cf5cfe389c809f2552029b7';
const HOST = process.env.REACT_APP_CONTENTFUL_HOST || 'cdn.contentful.com';
const SITE = 'Bronda';

const client = createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  host: HOST,
});

// get navigation
export const getNavi = (locale) => client.getEntries({
  content_type: 'navigation',
  'fields.site': SITE,
  limit: 1,
  include: 2,
  locale,
  select: [
    'fields.entries',
  ],
})
.then(response => response.items[0].fields.entries)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

export const getPage = (slug, locale) => client.getEntries({
  content_type: 'page',
  'fields.site': SITE,
  'fields.slug': slug,
  include: 2,
  locale,
  select: [
    'fields.slug',
    'fields.title',
    'fields.elements',
  ],
})
.then(response => response.items[0].fields)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

export const getReservationTexts = (locale) => client.getEntries({
  content_type: 'reservationTexts',
  'fields.site': SITE,
  limit: 1,
  locale,
  select: [
    'fields.onlineBookingInfo',
    'fields.groupReservationInfo'
  ]
})
.then(response => ({
  ...response.items[0].fields
}))
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getHours = (locale) => client.getEntries({
  content_type: 'contactUs',
  'fields.site': SITE,
  limit: 1,
  locale,
  select: [
    'fields.openingHours'
  ]
})
.then(response => response.items[0].fields.openingHours)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get front page
export const getFront = (locale) => client.getEntries({
  content_type: 'frontPage',
  'fields.site': SITE,
  limit: 1,
  locale,
  include: 10,
  select: [
    'fields.header',
    'fields.lifts',
    'fields.containers'
  ]
})
.then(response => {
  return {
    "header":response.items[0].fields.header.fields,
    "lifts":response.items[0].fields.lifts,
    "containers":response.items[0].fields.containers
  }
})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Menus
export const getMenus = (locale) => client.getEntries({
  content_type: 'menu',
 'fields.site': SITE,
  order: 'fields.order',
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get open hours
export const getContact = (locale) => client.getEntries({
  content_type: 'contactUs',
  'fields.site': SITE,
  limit: 1,
  include: 2,
  locale,
  select: [
    'fields.header',
    'fields.leftColumn',
    'fields.rightColumn'
  ]
})
.then(response => {
  return {
  "header":response.items[0].fields.header.fields,
  "leftColumn":response.items[0].fields.leftColumn,
  "rightColumn":response.items[0].fields.rightColumn
}})
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get Blogs
export const getBlogs = (locale, limit = 1, offset = 0) => client.getEntries({
  content_type: 'blogPost',
  'fields.site': SITE,
  order: '-fields.published',
  limit: limit,
  skip: offset,
  locale,
  // include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});

// get event
export const getEvents = (locale, date) => client.getEntries({
  content_type: 'event',
  'fields.site': SITE,
  order: 'fields.date',
  'fields.date[gte]': date,
  locale,
  include: 10
})
.then(response => response.items)
.catch(error => {
  console.log('error occured')
  console.log(error)
});



// WEBPACK FOOTER //
// ./src/api/contentfulAPI.js